import * as TypeGraphQL from "type-graphql";
export var AlpacaAccountType;
(function (AlpacaAccountType) {
    AlpacaAccountType["PAPER"] = "PAPER";
    AlpacaAccountType["LIVE"] = "LIVE";
})(AlpacaAccountType || (AlpacaAccountType = {}));
TypeGraphQL.registerEnumType(AlpacaAccountType, {
    name: "AlpacaAccountType",
    description: undefined,
});
//# sourceMappingURL=AlpacaAccountType.js.map